import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';

import ProjectOverview from './ProjectOverview/ProjectOverview';
import ProjectDocuments from './ProjectDocuments/ProjectDocuments';

export const ProjectContent = ({ match, projectID }) => {
  const documentsCategoryId = _.get(match, 'params.documentsCategoryId', null);

  const Content = documentsCategoryId ? <ProjectDocuments documentCategoryID={documentsCategoryId} />
    : <ProjectOverview projectID={projectID} />;

  return Content;
};

ProjectContent.defaultProps = {
  match: {},
  projectID: null,
};

ProjectContent.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.object,
  }),
  projectID: PropTypes.number,
};

export default withRouter(ProjectContent);
